<hive-inline-notification severity="warning" heading="Renew Your Subscription">
    Continue to get the best out of your Evergreen Subscription. Renew your subscription today!
</hive-inline-notification>
